module.exports = __webpack_public_path__ + "img/8.02b54c09.png";